import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { IconPlus, IconCalendar } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { getEvents } from "../db"; // ✅ Import function to fetch events
import LoadinPage from "../Components/LoadingPage";

const Events = () => {
    const { t } = useTranslation();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    // ✅ Fetch events on component mount
    useEffect(() => {

        const fetchEvents = async () => {
            const eventList = await getEvents();
            setEvents(eventList || []);
            setLoading(false);
        };
        fetchEvents();

        const handleEventsUpdated = async (e) => {
            if (e.tables?.includes('events')) {
                fetchEvents();
            }
        }
    }, []);

    return (
        <div className="p-4 flex flex-col h-full relative">
            <h1 className="text-2xl uppercase text-center font-black transform -skew-x-12 shrink-0 pb-4">
                {t("events.headline")}
            </h1>

            <div className="grow overflow-y-auto overflow-x-hidden flex flex-col gap-4">
                {/* ✅ Show loading spinner */}
                {loading ? (
                    <LoadinPage />
                ) : events.length === 0 ? (
                    <div className="font-bold">{t("events.noEventsFound")}</div>
                ) : (
                    <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 px-2">
                        {events.sort((a, b) => { const aDate = a.date ?? 0; const bDate = b.date ?? 0; return bDate - aDate; } ).map((event) => (
                            <Link key={event.id} to={`/events/${event.id}`} className={(event.type === 'race' ? 'button-primary' : 'button-secondary')}>
                                <div>
                                    <div className="font-semibold">{event.title}</div>
                                    <div className="text-xs">
                                        {new Intl.DateTimeFormat("cs-CZ", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        }).format(new Date(event.date * 1000))}
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>

            {/* ✅ Add New Event Button */}
            <Link
                to="/events/new"
                className="p-4 rounded-full bg-[var(--dark-color)] text-[var(--light-color)] absolute right-2 bottom-2"
            >
                <IconPlus className="w-6 h-auto" />
                <span className="sr-only">{t("event.addNew")}</span>
            </Link>
        </div>
    );
};

export default Events;
